module.exports = __webpack_public_path__ + "img/server-error-dark.4fd7ed4d.svg";